"use strict";

require("core-js/modules/es.array.reduce.js");

var _regeneratorRuntime = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

var _toArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/toArray");

var _defineProperty = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _commandBuilder = _interopRequireDefault(require("./commandBuilder"));

var _interpolationBuilder = _interopRequireDefault(require("./interpolationBuilder"));

var _types = _interopRequireDefault(require("../metadata/types"));

function pipelineBuilder(context) {
  var pipeline = [];
  return {
    addCommand: function addCommand(name) {
      var builder = (0, _commandBuilder.default)(name, context);
      pipeline.push(builder);
      return builder;
    },
    addArgument: function addArgument(interpolation) {
      var builder = (0, _interpolationBuilder.default)(interpolation);
      pipeline.push(builder);
      return this;
    },
    getMetadata: function getMetadata() {
      return _defineProperty({}, _types.default.PIPELINE, pipeline.map(function (segment) {
        return segment.getMetadata();
      }));
    },
    build: function build() {
      var buildOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _pipeline$map = pipeline.map(function (segment) {
        return segment.build(buildOpts);
      }),
          _pipeline$map2 = _toArray(_pipeline$map),
          first = _pipeline$map2[0],
          rest = _pipeline$map2.slice(1);

      var _pipeline$slice = pipeline.slice(-1),
          _pipeline$slice2 = _slicedToArray(_pipeline$slice, 1),
          last = _pipeline$slice2[0];

      var lastCommand = context.commandRegistry[last.name];
      var formatter = buildOpts.format !== false && lastCommand ? lastCommand.format : function (output) {
        return output;
      }; // last command won't exist if entire pipeline is interpolations

      return /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args, opts) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.t0 = formatter;
                  _context2.t1 = rest;

                  _context2.t2 = /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(val, cmd) {
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return cmd(val);

                            case 2:
                              return _context.abrupt("return", _context.sent);

                            case 3:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x3, _x4) {
                      return _ref3.apply(this, arguments);
                    };
                  }();

                  _context2.next = 5;
                  return first(args, opts);

                case 5:
                  _context2.t3 = _context2.sent;
                  _context2.next = 8;
                  return _context2.t1.reduce.call(_context2.t1, _context2.t2, _context2.t3);

                case 8:
                  _context2.t4 = _context2.sent;
                  return _context2.abrupt("return", (0, _context2.t0)(_context2.t4));

                case 10:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }();
    }
  };
}

var _default = pipelineBuilder;
exports.default = _default;